module.exports = __webpack_public_path__ + "static/img/industriales3.5abaf9c.png";